export default __webpack_public_path__ + "static/media/twitter.b0c9823e.webp";